import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from '@angular/core';

import { Skill } from '@mitel/cloudlink-sdk';
import { Subscription, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, startWith, skip  } from 'rxjs/operators';
import { SkillsService } from '../../../core/services/skills.service';
import { UsersFilterType } from '../../../core/constants/user-filter-constants';

@Component({
  selector: 'app-skills-filter',
  templateUrl: 'skills-filter.component.html',
  styleUrls: ['./skills-filter.component.scss']
})

export class SkillsFilterComponent implements OnInit, OnDestroy {
  @Input() accountId: string;
  @Input() eliminateSkills: string[] = [];
  @Input() parentProductCode: string;
  @Output() onSearch = new EventEmitter<SearchFilterResult>();

  @ViewChild('tagsearchbox', { static: true }) tagsearchbox: ElementRef;

  $searchTerm = new Subject<string>();
  selectedTags: string[] = [];
  filteredTags: string[] = [];
  searchPlaceholder: string = "";
  hideTags: boolean = false;
  suggestions: Observable<string[]>;
  tags: string[] = [];
  allSkills: Skill[] = [];
  tagsFilterPlaceholder: string = "integrations.cc-next.search-skill";
  disabled = false;

  private subs = new Subscription();

  constructor( 
	  private skillsService: SkillsService) {
  }

  ngOnInit() {
    this.tagsearchbox.nativeElement.focus(); // only sets focus the first time
    this.subs.add(this.$searchTerm.pipe(
      debounceTime(1000),
      startWith(''),
      distinctUntilChanged(),
      skip(1),
      switchMap( async term => {
        if (term) {
          term = term.toLowerCase();
          const filtered = this.tags.filter(t => t.toLowerCase().indexOf(term) >= 0);
          this.filteredTags = filtered;
        }
        else {
          this.filteredTags = this.tags;
        }
      })
      ).subscribe()
		);

    this.skillsService.getCachedAccountSkills().then( skills => {
      this.allSkills = this.eliminateSpecificSkills(skills);
      this.tags = this.allSkills.map(s => s.name);
      this.filteredTags = this.tags;
    })
  }

  eliminateSpecificSkills( skills: Skill[] )
  {
    if ( this.eliminateSkills.length == 0 )
      return skills;

    let tempList = new Array<Skill>();
    for ( var i = 0; i < skills.length; i++ )
    {
      if ( this.eliminateSkills.indexOf(skills[i].skillId) == -1 )
      {
        tempList.push(skills[i]);
      }
    }
    return tempList;
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  getTagColor(tag: string): string {
    return this.getHexColorForStringInput(tag);
  }

  addTagFilter(tag: string) {

    if (!this.selectedTags.includes(tag)) {
      this.selectedTags.push(tag);
      this.updateSearch();
    }
  }

  private updateSearch() {
    let info = new SearchFilterResult();
    info.displayStr = this.selectedTags[0];
    const skill = this.allSkills.find(s => s.name.toLowerCase() === this.selectedTags[0].toLowerCase());
    info.id = skill.skillId;
    info.data = {
      id: this.parentProductCode,
      subfilterId: 'cx-skills',
      filter: skill.skillId,
      type: UsersFilterType.PRODUCT
    }

    this.onSearch.emit(info);
  }

  getHexColorForStringInput(input: string) {
    let colour = '#';
  
    if (input) {
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
            hash = input.charCodeAt(i) + ((hash << 5) - hash);
        }
  
        for (let i = 0; i < 3; i++) {
            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }
    }
    else {
        colour = '#535356'
    }
  
    return colour;
  }

}

export class SearchFilterResult {
  displayStr: string;
  id: string;
  data: {
    type: UsersFilterType;
    id: string;
    subfilterId: string;
    filter: string;
  }
}
